module.exports = __webpack_public_path__ + "98170260012493704a04801dfacb23ec.pdf";